module.exports = __webpack_public_path__ + "img/Unicom-8.74e0377d.svg";